import { AspectOption } from "@dgs/core";

export const aspectRatios: AspectOption[] = [
	{ aspect: 16 / 9, name: "16 / 9" },
	{ aspect: 9 / 16, name: "9 / 16" },
	{ aspect: 4 / 3, name: "4 / 3" },
	{ aspect: 4, name: "4 / 1 - (Key Visual)" },
	{ aspect: 1, name: "1 / 1" },
];
